/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    ArticleOutlined,
    CalendarMonthOutlined,
    DoorFrontOutlined, InterpreterModeOutlined,
    OndemandVideoOutlined,
    PriceCheckOutlined,
    SchoolOutlined,
    SupportAgentOutlined,
    VideocamOutlined, WebOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Inicio from "./Secciones/Seccion_Inicio";
import Seccion_Calendario from "./Secciones/Seccion_Calendario";
import Seccion_Simulador_Comisiones from "./Secciones/Seccion_Simulador_Comisiones";
import Seccion_Soporte from "./Secciones/Seccion_Soporte";
import Seccion_Capacitaciones from "./Secciones/Seccion_Capacitaciones";
import Seccion_Documentos from "./Secciones/Seccion_Documentos";
import Seccion_Videos from "./Secciones/Seccion_Videos";
import Seccion_Videos_Empresarial from "./Secciones/Seccion_Videos_Empresarial";
import Seccion_Cap from "./Secciones/Seccion_Cap";
import Seccion_Resultados from "./SeccionesID/Seccion_Resultados";
import Seccion_Mixlrs from "./Secciones/Seccion_Mixlrs";
import Seccion_Pagina from "./Secciones/Seccion_Pagina";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)
    const [open, setOpen] = useState(false)


    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

        </Grid>
    )

}
export default Dashboard

const secciones = [

    {
        nombre: 'Inicio',
        icono: DoorFrontOutlined,
        camino: '*',
        categoria: 'Personal',
        Componente: <Seccion_Inicio/>

    },
    {
        nombre: 'Calendario',
        icono: CalendarMonthOutlined,
        camino: '/Calendario',
        categoria: 'Personal',
        Componente: <Seccion_Calendario/>

    },
    {
        nombre: 'Simulador Comision',
        icono: PriceCheckOutlined,
        camino: '/Comision',
        categoria: 'Personal',
        Componente: <Seccion_Simulador_Comisiones/>

    },
    {
        nombre: 'Pagina Personal',
        icono: WebOutlined,
        camino: '/Pagina',
        categoria: 'Personal',
        Componente: <Seccion_Pagina/>

    },
    {
        nombre: 'Capacitaciones',
        icono: SchoolOutlined,
        camino: '/Capacitaciones',
        categoria: 'Educacion',
        Componente: <Seccion_Capacitaciones/>

    },
    {
        nombre: 'Mixlrs',
        icono: InterpreterModeOutlined,
        camino: '/Mixlrs',
        categoria: 'Educacion',
        Componente: <Seccion_Mixlrs/>

    },
    {
        nombre: 'Documentos PDFs',
        icono: ArticleOutlined,
        camino: '/Documentos',
        categoria: 'Herramientas',
        Componente: <Seccion_Documentos/>

    },
    {
        nombre: 'Videos de YouTube',
        icono: OndemandVideoOutlined,
        camino: '/Videos',
        categoria: 'Herramientas',
        Componente: <Seccion_Videos/>

    },
    {
        nombre: 'Videos Empresariales',
        icono: VideocamOutlined,
        camino: '/Empresariales',
        categoria: 'Herramientas',
        Componente: <Seccion_Videos_Empresarial/>
    },
    {
        nombre: 'Soporte',
        icono: SupportAgentOutlined,
        camino: '/Soporte',
        categoria: 'Herramientas',
        Componente: <Seccion_Soporte/>
    }

]

const seccionesID = [
    {
        nombre: 'Caps',
        camino: '/Caps/:id',
        Componente: <Seccion_Cap/>
    },
    {
        nombre: 'Resultados',
        camino: '/Resultados/:id',
        Componente: <Seccion_Resultados/>
    },
    {
        nombre: 'Eventos',
        camino: '/Calendario/:id',
        Componente: <Seccion_Calendario/>
    },
    {
        nombre: 'Capacitaciones',
        camino: '/Capacitaciones/:id',
        Componente: <Seccion_Capacitaciones/>
    },
    {
        nombre: 'Mixlrs',
        camino: '/Mixlrs/:id',
        Componente: <Seccion_Mixlrs/>
    },
    {
        nombre: 'Videos',
        camino: '/Videos/:id',
        Componente: <Seccion_Videos/>
    },
    {
        nombre: 'Empresariales',
        camino: '/Empresariales/:id',
        Componente: <Seccion_Videos_Empresarial/>
    }


]

const seccionesPerfil = []

const notificaciones = {}